import { request } from "./http";

export interface LoginResponse {
  access_token: string;
  token_type: string;
}

export interface UserMe {
  id: string;
  email: string;
  is_active: boolean;
  is_verified: boolean;
  is_superuser: boolean;
  org_id: string;
  full_name: string | null;
  locale: string | null;
  totp_enabled: boolean;
}

export interface RegisterBody {
  email: string;
  password: string;
  org_id: string;
}

export interface RoleRef {
  id: string;
  name: string;
  is_system: boolean;
}

/** The caller's own effective permissions + roles (GET /api/v1/me/permissions). */
export interface MyAccess {
  /** Effective permission keys; `["*"]` for super-admins. */
  permissions: string[];
  roles: RoleRef[];
  is_super_admin: boolean;
}

export const auth = {
  login: (username: string, password: string, totp_code?: string) =>
    request<LoginResponse>("/auth/jwt/login", {
      method: "POST",
      form: true,
      body: { username, password, totp_code },
      skipAuthExpiredOn401: true,
    }),
  logout: () => request<void>("/auth/jwt/logout", { method: "POST" }),
  register: (body: RegisterBody) => request<UserMe>("/auth/register", { body }),
  me: () => request<UserMe>("/users/me"),
  myPermissions: () => request<MyAccess>("/api/v1/me/permissions"),

  mfa: {
    enroll: () =>
      request<{ secret: string; provisioning_uri: string }>("/auth/mfa/enroll", {
        method: "POST",
      }),
    verify: (code: string) =>
      request<{ totp_enabled: boolean }>("/auth/mfa/verify", { body: { code } }),
    disable: (code: string) =>
      request<{ totp_enabled: boolean }>("/auth/mfa/disable", { body: { code } }),
  },
};
